import './NavBar.css'

import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import { useCurrentUser } from './api/auth/queries/useCurrentUser'
import { useIsMobile } from './hooks/useIsMobile'
import { useIsNewDesign } from './hooks/useIsNewDesign'
import circleIconUser from './imgs/account_circle_white_24dp-biggg.svg'
import icon from './imgs/Logo_f.svg'
import logoutIcon from './imgs/logout_icon.svg'
import { QUERY_KEYS } from './lib/queryKeys'
import { cn } from './lib/utils'
import { ContactUs } from './pages/client-side/components/ContactUs'
import { RoutePath } from './RoutePath'
import { setIsAuthenticated } from './store/appSlice'

export default function NavBar() {
  const history = useHistory()
  const dispatch = useDispatch()
  const isMobile = useIsMobile()
  const { data: loggedUser } = useCurrentUser()
  const [isShowContactUs, setShowContactUs] = useState(false)
  const [isMobileMenuActive, setIsMobileMenuActive] = useState(false)
  const queryClient = useQueryClient()
  const isNewDesign = useIsNewDesign()

  const logOutHandler = async () => {
    try {
      localStorage.removeItem('cognito-tokens')
      dispatch(setIsAuthenticated(false))
      queryClient.setQueryData([QUERY_KEYS.LOGGED_USER], null)
      queryClient.clear()
      history.push('/')
    } catch (error) {
      throw error
    }
  }
  const onSetShowContactUs = () => {
    setIsMobileMenuActive(false)
    setShowContactUs(true)
  }
  function mobileMenu() {
    if (!isMobile) return
    setIsMobileMenuActive(prev => !prev)
  }

  return (
    <header className='header' data-bs style={isNewDesign ? { backgroundColor: 'white' } : undefined}>
      <nav className='navbar1'>
        <a href='http://www.shiptanbul.com/' className='nav-link1'>
          <img alt='icon' width='200px' src={icon} />
        </a>
        <ul className={cn('nav-menu', isMobileMenuActive && 'active')}>
          <li className='nav-item'>
            <a href='https://www.shiptanbul.com/about' className='nav-link1'>
              נעים להכיר
            </a>
          </li>
          <li className='nav-item'>
            <a href='https://www.shiptanbul.com/start-here' className='nav-link1'>
              איך זה עובד
            </a>
          </li>
          <li className='nav-item'>
            <a href='https://shiptanbul.com/shops/usa' className='nav-link1'>
              חנויות מומלצות
            </a>
          </li>
          <li className='nav-item'>
            <a href='https://www.shiptanbul.com/knowledge-center' className='nav-link1'>
              מרכז הידע והתמיכה
            </a>
          </li>
          <li className='nav-item'>
            <a href='https://shiptanbul.com/calculator' className='nav-link1'>
              מחשבונים
            </a>
          </li>
          <li className='nav-item'>
            {isNewDesign ? (
              <button className='nav-link1' onClick={onSetShowContactUs}>
                צור קשר
              </button>
            ) : (
              <a className='nav-link1' onClick={onSetShowContactUs}>
                צור קשר
              </a>
            )}
          </li>

          {loggedUser ? (
            <li className='nav-item nav-user'>
              <Link
                to={RoutePath.ClientProfile}
                className='nav-link1'
                onClick={() => {
                  mobileMenu()
                }}
              >
                <div>
                  {loggedUser.UserAttributes.name}
                  <img src={circleIconUser} />
                </div>
              </Link>
            </li>
          ) : (
            <li className='nav-item' style={{ marginLeft: '1rem' }}>
              <Link
                to='/'
                className='nav-link1'
                onClick={() => {
                  mobileMenu()
                }}
              >
                <Button variant='primary' style={{ maxWidth: '110px', fontSize: '15px' }}>
                  התחברות
                </Button>
              </Link>
            </li>
          )}

          {loggedUser && (
            <img
              src={logoutIcon}
              className='logout-btn'
              onClick={() => {
                logOutHandler()
                mobileMenu()
              }}
            />
          )}
        </ul>
        <div
          className={cn('hamburger', isMobileMenuActive && 'active')}
          onClick={() => {
            mobileMenu()
          }}
        >
          <span className='bar'></span>
          <span className='bar'></span>
          <span className='bar'></span>
        </div>
      </nav>
      <ContactUs show={isShowContactUs} setShow={setShowContactUs} />
    </header>
  )
}
